import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';

import { of } from 'rxjs/internal/observable/of';
import { Observable } from 'rxjs/internal/Observable';
import { catchError } from 'rxjs/internal/operators/catchError';
import { tap } from 'rxjs/internal/operators/tap';
import { throwError } from 'rxjs/internal/observable/throwError';

import { AuthService } from '../services/auth.service';
import { ToastService } from 'src/app/shared/utils/toast.service';

import { HttpStatusCode, SignOutReason } from '../constants/app.constant';
import { ClientError } from '../error/model/client-error';
import { ServerError } from '../error/model/server-error';
import { ConfirmDialogComponent } from '../dialog/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  /***************Properties***************/
  private handledSessionExpiration: Boolean = false;
  /***************Properties***************/

  /*********************Constructor*********************/
  constructor(
    private authService: AuthService,
    private toast: ToastService,
    public dialog: MatDialog,
  ) {

  }
  /*********************Constructor*********************/

  /*********************Implementation Methods*********************/

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap((event: HttpEvent<any>) => {}),
      catchError((error) => {
        if (this.handledSessionExpiration) {
           console.error('Session expired error:', error);
          return of(error);
        }

        if (error instanceof HttpErrorResponse) {
          let err = null;
           console.error('[API error]:', request.url);
            console.error('[Status error]:', error.status);
            console.error('[Response error]:', error.error);
            /**Thiss tells 
            which api failed  
            401.403 issues
            Backend error
            ***/

          if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred.
            err = new ClientError(error.error.message);
            console.error("[Client-side error]:", err.message);
          } else {
            // A server-side error occurred.
            err = new ServerError(error.error, error.status);
            console.error("[Server-side error]:", err.message);
            err.url = error.url;

            if (this.isSessionExpired(err)) {
              err.handled = true;
              this.handledSessionExpiration = true;
              let sessionMessage = err.faultInfos[0].faultMessage;
              let dialogRef = this.dialog.open(ConfirmDialogComponent, {
                width: '600px',
                data: {
                  title: 'Session Expired',
                  message: sessionMessage,
                  isOk:true,
                  isCancelNo:true
                },
                disableClose: true,
              });
              dialogRef.afterClosed().subscribe((result) => {
                  this.authService.logOut();
              })
            }


          }

          err.status = error.status;
          err.statusText = error.statusText;
          return throwError(err);
        }

        return throwError(error);
      })
    );
  }

  /*********************Implementation Methods*********************/

  /******************Private Methods******************/

  private isSessionExpired(error: ServerError): boolean {
    const sessionExpired =
      (error.status === HttpStatusCode.UnAuthorized || error.logoutUser) &&
      !this.handledSessionExpiration;

    if (this.handledSessionExpiration) {
      error.handled = true;
    }

    return sessionExpired;
  }

  /*********************Private Methods*********************/
}
